import { useState } from "react";
import { Plus } from "lucide-react";
import { ClientPicker } from "./ClientPicker";

export function MultiClientPicker({ clients, onChange }) {
  const [addingSlot, setAddingSlot] = useState(clients.length === 0);
  const excludeIds = clients.map((c) => c.id);

  const setClient = (index, client) => {
    const next = [...clients];
    next[index] = client;
    onChange(next);
    setAddingSlot(false);
  };
  const removeClient = (index) => onChange(clients.filter((_, i) => i !== index));

  return (
    <div className="space-y-2">
      {clients.map((c, i) => (
        <ClientPicker key={c.id} selected={c} onSelect={() => {}} onClear={() => removeClient(i)} excludeIds={excludeIds} />
      ))}
      {addingSlot && (
        <ClientPicker selected={null} onSelect={(client) => setClient(clients.length, client)} onClear={() => setAddingSlot(false)} excludeIds={excludeIds} />
      )}
      {!addingSlot && (
        <button type="button" data-testid="multi-client-add" onClick={() => setAddingSlot(true)} className="inline-flex items-center gap-1.5 text-sm font-medium text-[#0C2347] hover:text-[#123262] rounded-lg px-1 py-1">
          <Plus size={14} /> Add {clients.length ? "another " : ""}client
        </button>
      )}
    </div>
  );
}
